import { Geo2 } from "../../geography";
import { Scalar } from "../../math";
import { CalculatorBase } from "../geodesy.calculators";
export class PythagoreanFlatEarthCalculator extends CalculatorBase {
    constructor(e) {
        super(e);
    }
    getDistanceFromFloat(lata, lona, latb, lonb, alta, altb, deg) {
        if (lata === latb && lona === lonb) {
            return 0;
        }
        if (deg) {
            lata *= Scalar.DEG2RAD;
            lona *= Scalar.DEG2RAD;
            latb *= Scalar.DEG2RAD;
            lonb *= Scalar.DEG2RAD;
        }
        const a = Math.PI / 2 - lata;
        const b = Math.PI / 2 - latb;
        const c = Math.sqrt(a * a + b * b - 2 * a * b * Math.cos(lona - lonb));
        let distance = this._ellipsoid.semiMajorAxis * c;
        return distance;
    }
    getAzimuthFromFloat(lat1, lon1, lat2, lon2, deg) {
        if (lat1 === lat2 && lon1 === lon2) {
            return 0;
        }
        if (deg) {
            lat1 *= Scalar.DEG2RAD;
            lon1 *= Scalar.DEG2RAD;
            lat2 *= Scalar.DEG2RAD;
            lon2 *= Scalar.DEG2RAD;
        }
        const dLon = lon2 - lon1;
        const dLat = lat2 - lat1;
        let azimuth = Math.atan2(dLon, dLat);
        if (azimuth < 0) {
            azimuth += Scalar.PI_2;
        }
        if (deg) {
            azimuth *= Scalar.RAD2DEG;
        }
        return azimuth;
    }
    getLocationAtDistanceAzimuth(lat1, lon1, dist, az, deg) {
        const unit2deg = 1 / (((2 * Math.PI) / 360) * this._ellipsoid.semiMajorAxis);
        if (deg) {
            az *= Scalar.DEG2RAD;
            lat1 *= Scalar.DEG2RAD;
            lon1 *= Scalar.DEG2RAD;
        }
        let newLat = lat1 + dist * Math.cos(az) * unit2deg;
        let newLon = lon1 + (dist * Math.sin(az) * unit2deg) / Math.cos(lat1);
        if (deg) {
            newLat *= Scalar.RAD2DEG;
            newLon *= Scalar.RAD2DEG;
        }
        return new Geo2(newLat, newLon);
    }
}
PythagoreanFlatEarthCalculator.Shared = new PythagoreanFlatEarthCalculator();
//# sourceMappingURL=geodesy.calculator.flat.js.map